/**
 * Loops brand blue (light tint for accents, chips, etc.).
 */
export const loopsBlue = "#c9e2ff";
export const loopsBlueHover = "#b3d6fc";

/**
 * Follow CTA on restaurant list — darker blue, white text (not the loops tint).
 */
export const followButtonBlue = "#1877F2";
export const followButtonBlueHover = "#1663D4";
